import React from "react";

const DecorationSvg = props => (
  <svg width={457} height={405} className="decoration decoration-3" {...props}>
    <defs>
      <linearGradient
        x1="-65.269%"
        y1="53.356%"
        x2="103.565%"
        y2="52.02%"
        id="a"
      >
        <stop stopColor="#2B95FF" offset="0%" />
        <stop stopColor="#7F55FF" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle fill="url(#a)" opacity={0.2} cx={270} cy={187} r={187} />
      <circle fill="#3794FF" opacity={0.5} cx={187} cy={219} r={187} />
    </g>
  </svg>
);

export default DecorationSvg;
